module.exports = __webpack_public_path__ + "img/67.b0d353b7.jpg";